module.exports = __webpack_public_path__ + "img/Doc.1bc601bc.svg";